<template>
  <Modal
    v-if="show"
    :required="true"
    @close="close"
  >
    <template #header>
      <h5 class="mb-0">{{ submitalLocked ? 'Desbloquear submital' : 'Bloquear submital' }}</h5>
    </template>

    <template #body>
      <div class="d-flex mb-3">
        <div class="modal-icon flex-shrink-0" :class="submitalLocked ? 'modal-icon--unlock' : 'modal-icon--lock'">
          <font-awesome-icon :icon="['fas', submitalLocked ? 'lock-open-alt' : 'lock-alt']" fixed-width />
        </div>
        <div class="ml-3 fs-14 text-muted">
          {{ submitalLocked
            ? 'El submital vuelve a ser editable y la acción quedará registrada en el historial'
            : 'Se bloqueará la edición del submital y la acción quedará registrada en el historial' }}
        </div>
      </div>

      <b-form-group
        label="Justifique (obligatorio)"
        :state="descriptionState"
        invalid-feedback="Debe justificar la razón del desbloqueo (mínimo 14 caracteres)"
        class="mb-0"
      >
        <b-form-textarea
          v-model="form.description"
          rows="3"
          :state="descriptionState"
        />
      </b-form-group>

      <b-alert :show="Boolean(errorMessage)" variant="danger" class="fs-13 mt-3 mb-0">
        {{ errorMessage }}
      </b-alert>
    </template>

    <template #footer>
      <b-button variant="outline-dark" @click="close">
        Cancelar
      </b-button>
      <b-button
        :variant="submitalLocked ? 'primary' : 'warning'"
        :disabled="processing"
        @click="executeAction"
      >
        <span>{{ submitalLocked ? 'Desbloquear' : 'Bloquear' }} submital</span>
      </b-button>
    </template>
  </Modal>
</template>

<script>
import { mapGetters } from 'vuex'
import Modal from '../../shared/Modal'

export default {
  name: 'SubmitalLockModal',
  components: { Modal },
  props: {
    show: { type: Boolean, default: false }
  },
  data () {
    return {
      form: { description: '' },
      processing: false,
      submitted: false,
      errorMessage: ''
    }
  },
  computed: {
    ...mapGetters(['submitalLocked']),
    descriptionValid () {
      return this.form.description.trim().length >= 14
    },
    descriptionState () {
      if (!this.submitted) return null
      return this.descriptionValid
    }
  },
  methods: {
    reset () {
      this.form.description = ''
      this.submitted = false
      this.errorMessage = ''
    },
    close () {
      this.reset()
      this.$emit('close')
    },
    executeAction () {
      this.submitted = true
      if (!this.descriptionValid) return
      if (this.processing) return

      this.processing = true
      this.errorMessage = ''

      this.$store.dispatch('toggleSubmitalLock', this.form.description.trim())
        .then(() => {
          this.close()
        })
        .catch(e => {
          const data = e.response && e.response.data
          this.errorMessage = (data && data.error) || 'No se pudo completar la acción'
        })
        .finally(() => { this.processing = false })
    }
  }
}
</script>

<style scoped>
.modal-icon {
  padding: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
}
.modal-icon--lock   { background: #fdf3e2; color: #b3801a; }
.modal-icon--unlock { background: #e7f1ff; color: #0d6efd; }
</style>
